import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { gql } from '@apollo/client';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
export var useConsentStatus = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query I18nConsentStatus {\n      consentStatus\n    }\n  "]))), t.type({
  consentStatus: t["boolean"]
}));
var ProfileLanguageQuery = t.type({
  profile: t.type({
    id: t.string,
    language: t.type({
      code: t.string
    })
  })
});
export var useProfileLanguage = makeDecodedQuery(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    query ProfileLanguage {\n      profile {\n        id\n        language {\n          code\n        }\n      }\n    }\n  "]))), ProfileLanguageQuery);